export enum LoadJsBundle {
  placement = 'placement',
  comscore = 'comscore',
  googletag = 'gpt',
  growFaves = 'growFaves',
  pubnation = 'pubnation',
  gumgum = 'gumgum',
  videoPlayer = 'videoPlayer',
  nonLazyRequestsLoaded = 'nonLazyRequestsLoaded',
  zergnet_id = 'zergnet_id',
  zergnet_traffic_id = 'zergnet_traffic_id',
  p_and_g_pixel = 'p_and_g_pixel',
  ima = 'ima'
}
